import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { getSellPropertiesService } from 'services/addProperty.service';

const initialState = {
  sellPropertiesList: {
    totalCount: 0,
    totalPage: 0,
    sellPropertiesData: [],
  },
};

export const getSellProperties = createAsyncThunk(
  `GET_SELL_PROPERTIES`,
  async ({ page, limit, sortField, sortType, search }, { rejectWithValue }) => {
    try {
      const response = await getSellPropertiesService(
        page,
        limit,
        sortField,
        sortType,
        search
      );
      return response;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const propertiesSlice = createSlice({
  name: 'propertiesSlice',
  initialState,
  reducers: {
    resetSellPropertiesList: (state) => {
      state.sellPropertiesList = { ...initialState.sellPropertiesList };
    },
  },
  extraReducers: (builder) => {
    //   Get Sell Properties Listing
    builder
      .addCase(getSellProperties.fulfilled, (state, { payload }) => {
        if (!payload?.data?.isError) {
          const { count, totalPage, sellPropertiesList } = payload?.data?.data;
          state.sellPropertiesList = {
            totalCount: count ?? 0,
            totalPage: totalPage ?? 0,
            sellPropertiesData: [...(sellPropertiesList ?? [])],
          };
        }
      })
      .addCase(getSellProperties.rejected, (state, { payload }) => {
        toast.error(
          payload?.response?.data?.message ?? 'Something went wrong!'
        );
      });
  },
});

export const { resetSellPropertiesList } = propertiesSlice.actions;

export default propertiesSlice.reducer;
